import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function CustomerAccount() {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Your account</div>
      <h1 className="font-display text-4xl mb-2">Namaste, {user?.name}</h1>
      <p className="text-neutral-600">Track your venue inquiries and shortlists here.</p>
      <div className="mt-8 card-luxury p-6">
        <div className="text-sm">Email: {user?.email}</div>
        <div className="text-sm">Phone: {user?.phone || "—"}</div>
        <div className="text-sm">City: {user?.city || "—"}</div>
        <div className="text-sm capitalize">Target: {user?.target || "—"}</div>
        <div className="mt-4 flex gap-2">
          <Link to="/properties" className="btn-wine">Browse venues</Link>
        </div>
      </div>
    </div>
  );
}
